import moment from 'moment';
import { useParams } from 'react-router-dom';
import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useGuaranteedPrice } from '../../hooks/useGuaranteedPrice/useGuaranteedPrice';
import { datesFormat } from '../../config';
import { t } from '../common/Translate';
import { currencySign } from '../../Utils/currencySign';
import { Auth } from '../../config/configuration/react';

export const LinkedNcOrders = () => {
  const { recordId } = useParams();
  const today = new Date();
  const {
    firmValuation,
    nrmStatusId,
    originId,
    updateModalOpen,
    setUpdateModalOpen,
    orderConfirmationModalOpen,
    setOrderConfirmationModalOpen,
    selectedRowData,
    selectedDate,
    setSelectedDate,
    handleUpdateButtonClick,
    handleOrderConfirmationButtonClick,
    handleDateUpdateConfirm,
    handleOrderConfirm,
    guaranteedPrice,
  } = useGuaranteedPrice(recordId);
  const isSmart = originId === 12 || originId === 13 || originId === 14;
  const orderNotConfirmed = nrmStatusId === 15;
  const appLang = Auth.preferredLanguage();
  return (
    <div className="overflow-auto">
      <table className="table">
        <thead className="thead-light">
          <tr>
            <th>{t('offerId')}</th>
            {nrmStatusId === 30 && <th>{t('fcoId')}</th>}
            <th>{t('newCarBrand')}</th>
            <th>{t('newCarModel')}</th>
            <th>{t('deliveryDate')}</th>
            <th className="table-padding">{t('updateAt')}</th>
            <th>{t('firmTTCPrice')}</th>
            <th>{t('statusLabel')}</th>
            {isSmart && orderNotConfirmed && !Auth.roleViewerAccess() && (
              <>
                <th>{t('update')}</th>
                <th>{t('orderConfirmation')}</th>
              </>
            )}
          </tr>
        </thead>
        <tbody className="text-primary">
          {firmValuation.map((val) => (
            <tr order={val.id}>
              <td>{val.offerId}</td>
              {nrmStatusId === 30 && <td>{val.fcoId}</td>}
              <td>{val.newCarBrand}</td>
              <td>{val.newCarModel}</td>
              <td>{val.expectedDeliveryDate && moment(val.expectedDeliveryDate.date).format('YYYY-MM-DD')}</td>
              <td>{val.updatedAt && moment(val.updatedAt.date).format('YYYY-MM-DD HH:mm:ss')}</td>
              <td>
                {!(val.firmStatusId === 10 && val?.expectedDeliveryDate.date > guaranteedPrice?.maxExpectedDeliveryDate)
                  ? currencySign(val.firmTTCPrice >= 0 ? val.firmTTCPrice : 0)
                  : ''}
              </td>
              <td
                className={
                  val.firmStatusLabel === 'validated' || val.firmStatusLabel === 'confirmed' ? 'status-label-green' : ''
                }
              >
                {t(val.firmStatusLabel)}
              </td>
              {isSmart && orderNotConfirmed && (
                <>
                  <td>
                    {val.firmStatusLabel !== 'confirmed' && !Auth.roleViewerAccess() && (
                      <button
                        type="button"
                        className="btn btn-1-outline mr-2 less-padding"
                        onClick={() => handleUpdateButtonClick(val)}
                      >
                        {t('update')}
                      </button>
                    )}
                  </td>
                  <td>
                    {val.firmStatusLabel !== 'confirmed' && !Auth.roleViewerAccess() && (
                      <button
                        type="button"
                        className="btn btn-1-outline mr-2 less-padding"
                        onClick={() => handleOrderConfirmationButtonClick(val)}
                      >
                        {t('orderConfirmation')}
                      </button>
                    )}
                  </td>
                </>
              )}
            </tr>
          ))}
        </tbody>
      </table>
      <Modal isOpen={updateModalOpen} toggle={() => setUpdateModalOpen(!updateModalOpen)}>
        <ModalHeader className="update-date-modal">
          {selectedRowData && <p className="text">{t('updateNcOrderPopUpTittle')}</p>}
        </ModalHeader>
        <ModalBody className="update-date-modal">
          {selectedRowData && (
            <div>
              <p>
                {t('offerId')} : {selectedRowData.offerId}
              </p>
              <p>
                {t('newCarBrand')} : {selectedRowData.newCarBrand}
              </p>
              <p>
                {t('newCarModel')} : {selectedRowData.newCarModel}
              </p>
              <p className="text">{t('updateNcOrderPopUpsetEntryStockDate')}</p>
              <div className="form-group date-display">
                <p>{t('entryStockDate')}</p>
                <DatePicker
                  name="update-popup-date"
                  id="update-popup-date"
                  className="form-control"
                  selected={selectedDate}
                  onChange={(date) => setSelectedDate(date)}
                  dateFormat={appLang === 'DE' ? datesFormat[appLang] : datesFormat.default}
                  placeholderText={t('expectedDeliveryDate')}
                  autoComplete="off"
                  minDate={today}
                />
              </div>
            </div>
          )}
        </ModalBody>
        <ModalFooter className="justify-content-center update-date-modal">
          <div className="model-footer">
            <button type="button" className="btn btn-3 mr-2" onClick={() => setUpdateModalOpen(false)}>
              {t('close')}
            </button>
            <button type="button" className="btn btn-1" onClick={handleDateUpdateConfirm}>
              {t('confirm')}
            </button>
          </div>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={orderConfirmationModalOpen}
        toggle={() => setOrderConfirmationModalOpen(!orderConfirmationModalOpen)}
      >
        <ModalHeader className="update-date-modal">
          {selectedRowData && <p className="text">{t('confirmNcOrderPopUpTittle')}</p>}
        </ModalHeader>
        <ModalBody className="update-date-modal">
          {selectedRowData && (
            <div>
              <p>
                {t('offerId')} : {selectedRowData.offerId}
              </p>
              <p>
                {t('newCarBrand')} : {selectedRowData.newCarBrand}
              </p>
              <p>
                {t('newCarModel')} : {selectedRowData.newCarModel}
              </p>
              <p className="text">{t('confirmNcOrderPopUpsetEntryStockDate')}</p>
              <div className="form-group date-display">
                <p>{t('entryStockDate')}</p>
                <DatePicker
                  name="confirm-popup-date"
                  id="confirm-popup-date"
                  className="form-control"
                  selected={selectedDate}
                  onChange={(date) => setSelectedDate(date)}
                  dateFormat={appLang === 'DE' ? datesFormat[appLang] : datesFormat.default}
                  placeholderText={t('expectedDeliveryDate')}
                  autoComplete="off"
                  minDate={today}
                />
              </div>
            </div>
          )}
        </ModalBody>
        <ModalFooter className="justify-content-center update-date-modal">
          <div className="model-footer">
            <button type="button" className="btn btn-3 mr-2" onClick={() => setOrderConfirmationModalOpen(false)}>
              {t('close')}
            </button>
            <button type="button" className="btn btn-1" onClick={handleOrderConfirm}>
              {t('confirm')}
            </button>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  );
};
